import { render, staticRenderFns } from "./NotData.vue?vue&type=template&id=bc0a40e8&scoped=true"
import script from "./NotData.vue?vue&type=script&lang=js"
export * from "./NotData.vue?vue&type=script&lang=js"
import style0 from "./NotData.vue?vue&type=style&index=0&id=bc0a40e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0a40e8",
  null
  
)

export default component.exports